/* eslint-disable */

/**
 * Copyright (c) Grab
 * Grab Design Tokens Project
 * Do not edit directly
 */

export const awanColorBrandPrimary = '#00b14f';
export const awanColorBrandSecondary = '#005339';
export const awanColorBrandTertiary = '#d9fcde';
export const awanColorBackgroundPrimary = '#ffffff';
export const awanColorBackgroundSecondary = '#f5f5f5';
export const awanColorBackgroundTertiary = '#e8e8e8';
export const awanColorBackgroundBorder = '#bfbfbf';
export const awanColorBackgroundInverse = '#1a1a1a';
export const awanColorBackgroundPositive = '#00b14f';
export const awanColorBackgroundInformativeDefault = '#136fd8';
export const awanColorBackgroundInformativeAlt = '#ebfaff';
export const awanColorBackgroundNoticeDefault = '#faab00';
export const awanColorBackgroundNoticeAlt = '#fff9c0';
export const awanColorBackgroundNegativeDefault = '#d42e1c';
export const awanColorBackgroundNegativeAlt = '#fdf2f2';
export const awanColorSheetPrimary = '#ffffff';
export const awanColorSheetSecondary = '#e8e8e8';
export const awanColorSheetTertiary = '#dbdbdb';
export const awanColorSheetOverlay = 'rgba(0, 0, 0, 0.44)';
export const awanColorTextPrimary = '#1a1a1a';
export const awanColorTextSecondary = '#707070';
export const awanColorTextInverse = '#ffffff';
export const awanColorTextInactive = '#a3a3a3';
export const awanColorTextDisabled = '#bfbfbf';
export const awanColorTextLink = '#136fd8';
export const awanColorTextPositive = '#00b14f';
export const awanColorTextNegative = '#d42e1c';
export const awanColorTextNotice = '#faab00';
export const awanColorSymbolsPrimary = '#1a1a1a';
export const awanColorSymbolsSecondary = '#707070';
export const awanColorSymbolsInverse = '#ffffff';
export const awanColorSymbolsInactive = '#a3a3a3';
export const awanColorSymbolsDisabled = '#bfbfbf';
export const awanColorSymbolsSeparatorThin = '#e8e8e8';
export const awanColorSymbolsSeparatorThick = '#f5f5f5';
export const awanColorSymbolsLink = '#136fd8';
export const awanColorSymbolsPositive = '#00b14f';
export const awanColorSymbolsNegative = '#d42e1c';
export const awanColorSymbolsNotice = '#faab00';
export const awanColorSymbolsSafety = '#008388';
export const awanColorStatesPressedPrimary = '#03633e';
export const awanColorStatesPressedSecondary = '#d7dce4';
export const awanColorStatesPressedLink = '#0b54a8';
export const awanColorStatesPressedAlert = '#ac1e11';
export const awanColorStatesSelectedEnabled = '#00b14f';
export const awanColorStatesDeselectedEnabled = '#8c8c8c';
export const awanColorStatesDisabledPrimary = '#dbdbdb';
export const awanColorStatesDisabledSecondary = '#bfbfbf';
